import api from "./api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils";

export const ENDPOINT_DOCUMENT_TYPES = API_URL_VERSION + "tipo-documento";
export const ENDPOINT_DOCUMENT_TYPES_LIST = ENDPOINT_DOCUMENT_TYPES + "/listar";

export const documentsTypeService = {
    list: async (params) => {
        const searchParams = toSearchFilter(params);
        try {
            const response = await api.post(ENDPOINT_DOCUMENT_TYPES_LIST, searchParams);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "document-type.messages.errors.list";
        }
    },

    findMany: async () => {
        try {
            const response = await api.get(ENDPOINT_DOCUMENT_TYPES);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "document-type.messages.errors.list";
        }
    },

    create: async (data) => {
        try {
            const response = await api.post(ENDPOINT_DOCUMENT_TYPES, data);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.erros_validacao || "document-type.messages.errors.create";
            throw new Error(errorMessage);
        }
    },

    find: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_DOCUMENT_TYPES}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "document-type.messages.errors.find";
        }
    },

    update: async (id, data) => {
        try {
            const response = await api.put(`${ENDPOINT_DOCUMENT_TYPES}/${id}`, data);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.erros_validacao || "document-type.messages.errors.update";
            throw new Error(errorMessage);
        }
    },
};
